export var isObject = function (value, className) {
    if (className === void 0) { className = Object; }
    return value instanceof className;
};
//# sourceMappingURL=isObject.js.map